import { inject } from "@angular/core";
import { map, Observable, throwError } from "rxjs";

import { Wallet } from "@app/core/wallet/domain/model/wallet";
import { WalletRepo } from "@app/core/wallet/domain/repository/wallet.repo";
import { GetWalletWS } from "@app/core/wallet/infraestructure/webservice/get-wallet.ws";
import { WalletWSMapper } from "@app/core/wallet/infraestructure/mapper/wallet.mapper";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";

export class WalletDataRepo implements WalletRepo {
  private readonly getWalletWS = inject(GetWalletWS);
  private readonly tokenRepo = inject(TokenRepo);

  private readonly mapper = new WalletWSMapper();

  find(): Observable<Wallet> {
    const token = this.tokenRepo.get();

    if (token == null) {
      return throwError(() => new MissingCredentialsError());
    }

    return this.getWalletWS
      .execute(token)
      .pipe(map((wallet) => this.mapper.deserialize(wallet)));
  }
}
